// extracted by mini-css-extract-plugin
module.exports = {"container":"DefectFormKeyValuePair_container__3NdHZ","content":"DefectFormKeyValuePair_content__GWKAK"};